<template>
    <div class="slm-event-list__load-more">
        <button class="slm-load-more" @click="loadMore()">Visa fler</button>
    </div>
</template>

<script>
export default {
    name: 'load-more-component',
    props: ['id'],
    computed: {
        page() {
            return this.id === 'upcoming' ? this.$store.state.upcoming.page : this.$store.state.past.page;
        }
    },
    methods: {
        loadMore() {
            this.$store.commit('setPage', {
                id: this.id, 
                page: this.page + 1
            });
            this.$store.dispatch('setUrl');
            this.$store.dispatch('newSearch', this.id);
        }
    }
}
</script>